import "reflect-metadata";
import {inject, injectable} from "inversify";
import {UserEntity} from "@dropDesk/domain/entities/user/user.entity";
import {UserRepository} from "@dropDesk/domain/repositories/user/user.repository";

@injectable()
export class DeleteUserUseCase {
  private _repository: UserRepository;

  constructor(@inject(UserRepository) repository: UserRepository) {
    this._repository = repository;
  }

  public call(users: UserEntity[]): Promise<void> {
    return this._repository.delete(users);
  }
}

